<template>
  <div class="q-gutter-lg">
    <CTitle large>
      {{ $t('Identity Provider Settings') }}
    </CTitle>

    <Button :label="$t('Add identity provider')" icon="add" @click="() => openModal('')" />
    <DataTable :tableData="tableData" @openModal="openModal" />

    <FormModal :identityProviderData="identityProviderData" v-model="formModalVisible" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Button from '@design-system/components/Button.vue';

import CTitle from '@/components/uikit/CTitle';

import DataTable from './IdentityProviderDataTable';
import FormModal from './IdentityProviderDialogAdd';

const messages = {
  en: {
    'Identity Provider Settings': 'Identity Provider Settings',
    'Add identity provider': 'Add identity provider',
  },
  ja: {
    'Identity Provider Settings': 'IdP設定',
    'Add identity provider': 'IdPを追加',
  },
};

export default {
  name: 'IdentityProviderSettings',
  components: { Button, CTitle, DataTable, FormModal },
  i18n: { messages },
  data() {
    return {
      formModalVisible: false,
      identityProviderData: {},
    };
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    ...mapActions('identityProviders', {
      fetchIdentityProviders: 'fetchIdentityProviders',
    }),

    async fetchData() {
      this.loading = true;
      await this.fetchIdentityProviders();
      this.loading = false;
    },

    openModal(id) {
      this.formModalVisible = true;
      this.identityProviderData = id ? this.identityProviders.find(item => item.id === id) : {};
    },
  },
  computed: {
    ...mapGetters('identityProviders', {
      identityProviders: 'identityProviders',
    }),

    tableData() {
      return this.identityProviders;
    },
  },
};
</script>
